import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconImolaMinimapMarkers = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={375}
    height={375}
    fill="none"
    viewBox="0 0 375 375"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#icon-imola-minimap-markers_svg__a)">
      <path
        fill="url(#icon-imola-minimap-markers_svg__b)"
        fillOpacity={0.2}
        stroke="#fff"
        strokeOpacity={0.1}
        strokeWidth={10}
        d="M220.893 184.813c-2.08-.595-4.903-.595-6.686-.446a36650.064 36650.064 0 0 1-36.103 2.823c-1.548.119-8.629.665-16.842 1.3l-17 1.312-6.57.508c-2.526.446-3.417-1.189-3.714-2.229-.298-1.04-1.291-2.963-2.229-3.12-1.783-.297-3.12.594-3.863 1.04-.686.412-7.874 4.012-9.806 5.052-1.529.823-10.506 5.091-16.318 8.087-1.531.789-2.841 1.489-3.74 2.016-4.992 2.926-16.342 12.48-17.234 13.52-3.686 3.269-12.034 12.926-14.114 15.452-1.665 2.02-6.39 7.428-10.55 12.183-2.328 3.333-5.937 6.29-9.862 8.857-5.844 3.821-12.386 6.777-16.436 8.823a42.93 42.93 0 0 0-2.227 1.189c-.574.334-6.389 2.971-7.726 4.754-1.337 1.783-.842 3.863-.446 4.903.679 1.39 1.62 3.243 2.614 5.163a461.762 461.762 0 0 0 2.893 5.5c.958 1.791 1.736 3.206 2.07 3.748 1.189 1.932 3.227 2.862 4.16 2.972 2.526.297 4.755-.446 5.795-1.04.595-.34 2.767-1.365 5.803-2.768 6.367-2.943 16.532-7.553 23.912-11.006a489.879 489.879 0 0 0 3.862-1.826c10.55-5.052 18.424-8.172 24.664-9.063 6.24-.892 29.417-1.783 37.886-2.526l.604-.053c8.095-.711 12.812-1.125 20.642-.69 7.012.39 6.389.891 29.269 4.309 23.421 3.498 30.606 1.443 38.629.297 6.24-.892 26.66-4.409 31.498-5.497.665-.15 1.346-.319 2.034-.501 5.451-1.443 11.34-3.743 13.715-4.402 2.674-.743 4.648-1.203 5.645-2.823 1.189-1.932.743-1.486 1.783-7.429.556-3.177 1.629-4.496 2.857-5.421.609-.459 1.257-.821 1.898-1.265 1.943-1.096 5.113-2.8 8.15-4.516 2.999-1.694 5.869-3.401 7.301-4.547 3.715-2.971 4.755-7.131 5.349-9.211.2-.7 13.869-43.286 19.562-60.742 1.373-4.21 2.282-6.959 2.427-7.305.743-1.783.297-4.754.149-5.497-.149-.743-1.58-5.576-3.269-9.658-1.783-4.308.942-6.463 1.188-6.685.494-.445 1.744-1.694 3.405-3.355l.013-.013c3.334-3.335 8.32-8.32 12.183-11.787.73-.716 1.597-1.56 2.549-2.487l.095-.093c2.654-2.586 5.944-5.793 8.757-8.62 2.944-2.96 5.365-5.503 5.982-6.48 1.931-2.972.148-5.943-.594-6.983-.743-1.04-2.675-2.377-4.755-2.526-1.664-.119-5.646.743-7.429 1.189-9.244 1.931-28.101 5.657-40.263 8.202-.933.195-1.827.384-2.674.564-9.837 2.09-16.343 2.647-23.921 2.377-4.088-.146-14.2-1.502-21.666-2.377-3.658-.43-6.68-.743-8.048-.743-4.16 0-7.429 3.12-8.469 4.903l-.066.113c-.593 1.014-.745 1.276-1.688 3.761-.59 1.556-1.49 3.983-3.001 8.012-4.233 11.289-2.377 17.977-1.931 21.394.325 2.492 4.988 17.667 7.668 26.594.995 3.313 1.716 5.766 1.841 6.389.594 2.972-.446 4.309-1.04 5.349-1.437 2.774-3.982 7.34-4.457 8.172-.595 1.04-2.972 6.24-5.052 7.28-2.08 1.04-6.983-1.783-9.063-2.377Z"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M42.762 284.412c6.367-2.943 16.532-7.553 23.912-11.006"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M24.934 281.5c.958 1.791 1.736 3.206 2.07 3.748 1.189 1.932 3.227 2.862 4.16 2.972 2.526.297 4.755-.446 5.795-1.04.595-.34 2.767-1.365 5.802-2.768"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M22.04 276a461.762 461.762 0 0 0 2.892 5.5"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M19.43 270.837c.679 1.39 1.62 3.243 2.614 5.163"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M19.427 270.837c-.396-1.04-.89-3.12.446-4.903 1.337-1.783 7.152-4.42 7.726-4.755.607-.354 1.36-.75 2.227-1.188"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M46.264 251.167c-5.844 3.822-12.386 6.778-16.436 8.824"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M101.762 199.14c-1.531.789-2.841 1.49-3.74 2.016-4.992 2.926-16.342 12.48-17.234 13.52-3.686 3.269-12.034 12.926-14.114 15.452-1.665 2.02-6.39 7.428-10.55 12.183-2.328 3.334-5.937 6.29-9.862 8.857"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M127.886 186.001c-.686.412-7.874 4.011-9.806 5.051-1.529.824-10.506 5.092-16.318 8.088"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M127.887 186.001c.742-.445 2.08-1.337 3.863-1.04.938.157 1.931 2.08 2.228 3.12.298 1.04 1.189 2.675 3.715 2.229l6.57-.508"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="m161.262 188.49-17 1.313"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M196.262 185.775c-8.105.633-16.279 1.27-18.158 1.415l-16.842 1.3"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M220.893 184.812c-2.08-.594-4.903-.594-6.686-.445-.915.076-9.391.74-17.945 1.408"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M220.891 184.813c2.08.594 6.983 3.417 9.063 2.377 2.08-1.04 4.457-6.24 5.051-7.28"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M235.008 179.91c.475-.832 3.021-5.398 4.457-8.172.594-1.04 1.634-2.377 1.04-5.349-.125-.623-.846-3.076-1.841-6.389"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M235.928 104c-.59 1.556-1.49 3.983-3 8.012-4.234 11.289-2.377 17.977-1.932 21.394.325 2.492 4.989 17.667 7.668 26.594"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M246.152 95.223c-4.16 0-7.428 3.12-8.468 4.903-.649 1.111-.777 1.299-1.754 3.874"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M246.148 95.223c1.368 0 4.391.314 8.049.743"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M302.46 95.402c-.933.195-1.827.383-2.674.563-9.837 2.09-16.343 2.648-23.921 2.378-4.088-.146-14.2-1.502-21.666-2.378"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M342.724 87.2c-9.244 1.931-28.101 5.657-40.263 8.202"
      />
      <path
        stroke="#00FF2B"
        strokeLinecap="round"
        strokeWidth={4}
        d="M342.723 87.2c1.783-.446 5.764-1.308 7.429-1.189 2.08.149 4.011 1.486 4.754 2.526.743 1.04 2.525 4.011.594 6.983-.617.977-3.037 3.52-5.982 6.48"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M340.762 110.62c2.654-2.586 5.944-5.793 8.757-8.62"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M325.922 125c3.335-3.335 8.328-8.328 12.196-11.8.755-.739 1.655-1.617 2.644-2.58"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M322.516 128.355c.494-.445 1.743-1.694 3.404-3.355"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M322.517 128.354c-.247.223-2.972 2.378-1.189 6.686 1.689 4.082 3.12 8.915 3.269 9.658M324.599 144.698c.148.743.594 3.714-.149 5.497-.144.346-1.053 3.095-2.427 7.305"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M289.812 232c2.999-1.694 5.869-3.401 7.301-4.547 3.715-2.971 4.755-7.131 5.349-9.211.2-.7 13.869-43.286 19.562-60.742"
      />
      <path
        stroke="#CCC"
        strokeLinecap="round"
        strokeWidth={4}
        d="M279.762 237.781c.609-.459 1.257-.821 1.898-1.265 1.943-1.096 5.113-2.8 8.15-4.516"
      />
      <path
        stroke="#00FFE8"
        strokeLinecap="round"
        strokeWidth={4}
        d="M269.477 253.454c2.674-.743 4.648-1.203 5.645-2.823 1.189-1.932.743-1.486 1.783-7.429.556-3.176 1.629-4.496 2.857-5.421"
      />
      <path
        stroke="#FFC107"
        strokeLinecap="round"
        strokeWidth={4}
        d="M269.477 253.454c-2.375.659-8.264 2.959-13.715 4.402"
      />
      <path
        stroke="#FF5252"
        strokeLinecap="round"
        strokeWidth={4}
        d="M66.672 273.406a488.195 488.195 0 0 0 3.863-1.826c10.549-5.052 18.423-8.172 24.663-9.063 6.24-.892 29.418-1.783 37.886-2.526 8.469-.743 13.223-1.189 21.246-.743 7.012.39 6.389.892 29.269 4.309 23.422 3.498 30.607 1.443 38.63.297 6.24-.892 26.659-4.409 31.497-5.497.666-.15 1.346-.318 2.034-.501"
      />
      <g filter="url(#icon-imola-minimap-markers_svg__c)">
        <path
          fill="#fff"
          fillOpacity={0.95}
          d="m115.77 281.741-4.024.18-.202-4.521 4.024-.18zM115.363 272.699l-4.024.18-.202-4.521 4.024-.18zM114.961 263.656l-4.024.18-.202-4.521 4.024-.18zM114.555 254.614l-4.024.18-.202-4.521 4.024-.18zM114.152 245.571l-4.024.18-.202-4.521 4.024-.18zM111.543 277.4l-4.024.18-.202-4.521 4.024-.18zM111.141 268.357l-4.024.18-.202-4.521 4.024-.18zM110.734 259.315l-4.024.18-.202-4.521 4.024-.18zM110.328 250.272l-4.024.18-.202-4.521 4.024-.18z"
        />
        <path
          fill="#000"
          d="m111.746 281.921-4.024.18-.202-4.521 4.024-.18zM111.34 272.879l-4.024.18-.202-4.521 4.024-.18zM110.938 263.836l-4.024.18-.202-4.521 4.024-.18zM110.531 254.794l-4.024.18-.202-4.521 4.024-.18zM110.129 245.751l-4.024.18-.202-4.521 4.024-.18zM115.566 277.22l-4.024.18-.202-4.521 4.024-.18zM115.164 268.177l-4.024.18-.202-4.521 4.024-.18zM114.758 259.135l-4.024.18-.202-4.521 4.024-.18zM114.355 250.092l-4.024.18-.202-4.521 4.024-.18z"
        />
        <path
          fill="#E2645A"
          d="m139.604 234.246-15.245-9.184.883 19.742 14.362-10.558Zm2.261-.101c.033.728-.236 1.42-.816 1.835l-15.067 11.026c-1.158.878-2.695-.025-2.766-1.626l-.929-20.759c-.07-1.553 1.378-2.638 2.608-1.915l15.994 9.685c.617.41.946 1.075.976 1.754Z"
        />
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__d)">
        <rect
          width={20.8}
          height={20.8}
          x={155.41}
          y={232.747}
          fill="url(#icon-imola-minimap-markers_svg__e)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__f)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m165.637 240.823-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__g)">
        <rect
          width={20.8}
          height={20.8}
          x={250.5}
          y={226.506}
          fill="url(#icon-imola-minimap-markers_svg__h)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__i)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m257.905 239.742 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356v1.188h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__j)">
        <rect
          width={20.8}
          height={20.8}
          x={279.914}
          y={243.741}
          fill="url(#icon-imola-minimap-markers_svg__k)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__l)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M287.101 257.505v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34l-1.236 1.236h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__m)">
        <rect
          width={20.8}
          height={20.8}
          x={276.945}
          y={199.763}
          fill="url(#icon-imola-minimap-markers_svg__n)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__o)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M288.053 213.155h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02v1.608h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__p)">
        <rect
          width={20.8}
          height={20.8}
          x={296.555}
          y={132.608}
          fill="url(#icon-imola-minimap-markers_svg__q)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__r)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M303.844 146.372v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996v-4.212h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904l-1.236 1.236h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__s)">
        <rect
          width={20.8}
          height={20.8}
          x={329.539}
          y={125.476}
          fill="url(#icon-imola-minimap-markers_svg__t)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__u)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M336.849 139.24v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772l-1.236 1.236h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__v)">
        <rect
          width={20.8}
          height={20.8}
          x={272.488}
          y={71.395}
          fill="url(#icon-imola-minimap-markers_svg__w)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__x)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M279.644 85.16v-2.34l.756-.756-.636-.636V79.23L281 77.996h3.528l1.236 1.236v2.195l-.636.636.756.757v2.34l-1.236 1.236h-3.768l-1.236-1.237Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.391l.48.48h2.256Zm.12 3.647.48-.48v-1.523l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__y)">
        <rect
          width={20.8}
          height={20.8}
          x={317.355}
          y={92.196}
          fill="url(#icon-imola-minimap-markers_svg__z)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__A)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M328.917 100.224v-.228h-4.248v-1.2h5.688v1.464l-3.348 6.936h-1.464l3.372-6.972Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__B)">
        <rect
          width={20.8}
          height={20.8}
          x={240.098}
          y={101.11}
          fill="url(#icon-imola-minimap-markers_svg__C)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__D)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="M247.438 114.874v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928l-1.236 1.236h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__E)">
        <rect
          width={20.8}
          height={20.8}
          x={202.062}
          y={118.642}
          fill="url(#icon-imola-minimap-markers_svg__F)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__G)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m208.303 126.718-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736l-1.332 1.332h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__H)">
        <rect
          width={20.8}
          height={20.8}
          x={247.527}
          y={156.38}
          fill="url(#icon-imola-minimap-markers_svg__I)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__J)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m255.385 164.456-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.739 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__K)">
        <rect
          width={20.8}
          height={20.8}
          x={220.484}
          y={194.117}
          fill="url(#icon-imola-minimap-markers_svg__L)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__M)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m227.188 202.193-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.07 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356v1.188h-5.784v-1.764Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__N)">
        <rect
          width={20.8}
          height={20.8}
          x={202.062}
          y={157.568}
          fill="url(#icon-imola-minimap-markers_svg__O)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__P)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m208.596 165.644-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34l-1.236 1.236h-3.528l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__Q)">
        <rect
          width={20.8}
          height={20.8}
          x={134.609}
          y={162.025}
          fill="url(#icon-imola-minimap-markers_svg__R)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__S)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m141.284 170.101-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.802 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02v1.608h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__T)">
        <rect
          width={20.8}
          height={20.8}
          x={106.383}
          y={162.025}
          fill="url(#icon-imola-minimap-markers_svg__U)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__V)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m112.899 170.101-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.142 5.688v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996v-4.212h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904l-1.236 1.236h-3.504l-1.236-1.236Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__W)">
        <rect
          width={20.8}
          height={20.8}
          x={31.203}
          y={222.049}
          fill="url(#icon-imola-minimap-markers_svg__X)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__Y)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m37.62 230.125-1.836.948v-1.284l2.076-1.14h1.152v8.4H37.62v-6.924Zm3.262 5.688v-5.928l1.236-1.236h3.528l1.236 1.236v1.104H45.49v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772l-1.236 1.236h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__Z)">
        <rect
          width={20.8}
          height={20.8}
          x={5.352}
          y={234.827}
          fill="url(#icon-imola-minimap-markers_svg__aa)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__ab)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m12.371 242.903-1.835.948v-1.284l2.075-1.14h1.152v8.4h-1.392v-6.924Zm6.91-.048v-.228h-4.247v-1.2h5.688v1.464l-3.348 6.936H15.91l3.372-6.972Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__ac)">
        <rect
          width={20.8}
          height={20.8}
          x={26.152}
          y={293.365}
          fill="url(#icon-imola-minimap-markers_svg__ad)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__ae)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m32.475 301.441-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.202 5.688v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34l-1.236 1.236h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48H37.67l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468H37.55l-.48.468v1.524l.48.48h2.496Z"
          />
        </g>
      </g>
      <g filter="url(#icon-imola-minimap-markers_svg__af)">
        <rect
          width={20.8}
          height={20.8}
          x={73.398}
          y={237.798}
          fill="url(#icon-imola-minimap-markers_svg__ag)"
          rx={10.4}
        />
        <g filter="url(#icon-imola-minimap-markers_svg__ah)">
          <path
            fill="#000"
            fillOpacity={0.8}
            d="m79.786 245.874-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.322 5.688v-1.02H84.5v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236H87.8l1.236 1.236v5.928l-1.236 1.236h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48H84.86l-.48.48v1.932l.48.48h1.896Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="icon-imola-minimap-markers_svg__c"
        width={60.844}
        height={82.397}
        x={94.094}
        y={214.705}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={3}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__d"
        width={36.801}
        height={36.8}
        x={147.41}
        y={226.747}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__f"
        width={19.227}
        height={24.4}
        x={155.801}
        y={233.347}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__g"
        width={36.801}
        height={36.8}
        x={242.5}
        y={220.506}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__i"
        width={21.832}
        height={24.4}
        x={249.855}
        y={227.106}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__j"
        width={36.801}
        height={36.8}
        x={271.914}
        y={237.741}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__l"
        width={22}
        height={24.4}
        x={279.102}
        y={244.341}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__m"
        width={36.801}
        height={36.8}
        x={268.945}
        y={193.763}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__o"
        width={22.492}
        height={24.4}
        x={275.973}
        y={200.363}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__p"
        width={36.801}
        height={36.8}
        x={288.555}
        y={126.608}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__r"
        width={21.977}
        height={24.4}
        x={295.844}
        y={133.208}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__s"
        width={36.801}
        height={36.8}
        x={321.539}
        y={119.476}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__u"
        width={22.051}
        height={24.4}
        x={328.848}
        y={126.076}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__v"
        width={36.801}
        height={36.8}
        x={264.488}
        y={65.395}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__x"
        width={22.238}
        height={24.4}
        x={271.645}
        y={71.996}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__y"
        width={36.801}
        height={36.8}
        x={309.355}
        y={86.196}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__A"
        width={21.688}
        height={24.4}
        x={316.668}
        y={92.796}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__B"
        width={36.801}
        height={36.8}
        x={232.098}
        y={95.11}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__D"
        width={22.051}
        height={24.4}
        x={239.316}
        y={101.71}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__E"
        width={36.801}
        height={36.8}
        x={194.062}
        y={112.642}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__G"
        width={27.383}
        height={24.4}
        x={198.469}
        y={119.242}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__H"
        width={36.801}
        height={36.8}
        x={239.527}
        y={150.38}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__J"
        width={23.965}
        height={24.4}
        x={245.551}
        y={156.98}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__K"
        width={36.801}
        height={36.8}
        x={212.484}
        y={188.117}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__M"
        width={26.691}
        height={24.4}
        x={217.352}
        y={194.718}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__N"
        width={36.801}
        height={36.8}
        x={194.062}
        y={151.568}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__P"
        width={26.855}
        height={24.4}
        x={198.762}
        y={158.168}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__Q"
        width={36.801}
        height={36.8}
        x={126.609}
        y={156.025}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__S"
        width={27.047}
        height={24.4}
        x={131.449}
        y={162.625}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__T"
        width={36.801}
        height={36.8}
        x={98.383}
        y={156.025}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__V"
        width={26.953}
        height={24.4}
        x={103.062}
        y={162.625}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__W"
        width={36.801}
        height={36.8}
        x={23.203}
        y={216.049}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__Y"
        width={27.145}
        height={24.4}
        x={27.785}
        y={222.649}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__Z"
        width={36.801}
        height={36.8}
        x={-2.648}
        y={228.827}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__ab"
        width={26.188}
        height={24.4}
        x={2.535}
        y={235.427}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__ac"
        width={36.801}
        height={36.8}
        x={18.152}
        y={287.365}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__ae"
        width={27.277}
        height={24.4}
        x={22.641}
        y={293.965}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__af"
        width={36.801}
        height={36.8}
        x={65.398}
        y={231.798}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <filter
        id="icon-imola-minimap-markers_svg__ah"
        width={27.086}
        height={24.4}
        x={69.949}
        y={238.398}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9494_90719"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9494_90719"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9494_90719"
          result="effect2_dropShadow_9494_90719"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9494_90719"
          result="shape"
        />
      </filter>
      <linearGradient
        id="icon-imola-minimap-markers_svg__b"
        x1={19}
        x2={356.37}
        y1={188.126}
        y2={188.126}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4FC5BA" />
        <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__e"
        x1={176.21}
        x2={155.41}
        y1={232.747}
        y2={253.547}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__h"
        x1={271.3}
        x2={250.5}
        y1={226.506}
        y2={247.307}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__k"
        x1={300.714}
        x2={279.914}
        y1={243.741}
        y2={264.541}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__n"
        x1={297.746}
        x2={276.945}
        y1={199.763}
        y2={220.564}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__q"
        x1={317.355}
        x2={296.555}
        y1={132.608}
        y2={153.408}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__t"
        x1={350.339}
        x2={329.539}
        y1={125.476}
        y2={146.277}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__w"
        x1={293.289}
        x2={272.488}
        y1={71.395}
        y2={92.196}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__z"
        x1={338.156}
        x2={317.355}
        y1={92.196}
        y2={112.996}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__C"
        x1={260.898}
        x2={240.098}
        y1={101.11}
        y2={121.911}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__F"
        x1={222.863}
        x2={202.063}
        y1={118.642}
        y2={139.442}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__I"
        x1={268.328}
        x2={247.527}
        y1={156.38}
        y2={177.18}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__L"
        x1={241.285}
        x2={220.484}
        y1={194.117}
        y2={214.918}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__O"
        x1={222.863}
        x2={202.062}
        y1={157.568}
        y2={178.369}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__R"
        x1={155.41}
        x2={134.609}
        y1={162.025}
        y2={182.826}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__U"
        x1={127.183}
        x2={106.383}
        y1={162.025}
        y2={182.826}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__X"
        x1={52.003}
        x2={31.203}
        y1={222.049}
        y2={242.85}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__aa"
        x1={26.152}
        x2={5.352}
        y1={234.827}
        y2={255.627}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__ad"
        x1={46.953}
        x2={26.152}
        y1={293.365}
        y2={314.165}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <linearGradient
        id="icon-imola-minimap-markers_svg__ag"
        x1={94.199}
        x2={73.398}
        y1={237.798}
        y2={258.598}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <clipPath id="icon-imola-minimap-markers_svg__a">
        <path fill="#fff" d="M0 0h375v375H0z" />
      </clipPath>
    </defs>
  </svg>
));
export default SvgIconImolaMinimapMarkers;
